import { render, staticRenderFns } from "./GogoRuntimeRouterView.vue?vue&type=template&id=56894e31"
import script from "./GogoRuntimeRouterView.vue?vue&type=script&lang=ts"
export * from "./GogoRuntimeRouterView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports